import React from 'react';
import { scrollToSection } from '../utils/scrollToSection';
import { content } from '../content/about.content';
import Button from './common/Button';

const AboutUs = () => {

  return (
    <section id="about" className="bg-secondary py-12">
      <div className="container mx-auto px-6 max-w-4xl">
        <h2 className="text-4xl font-bold text-center mb-6">{content.name}</h2>

        <p className="text-center text-text leading-relaxed">
          {content.description}
        </p>

        <div className="text-center my-12">

          <Button
            href="#services"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('services');
            }}
            className="px-16 py-4 hover:bg-primary-100 transition"
          >
            Learn More About Us
          </Button>

        </div>
      </div>
    </section>
  );
};

export default AboutUs;
